import styled, { Interpolation, keyframes } from 'styled-components';

type props = {
    styles?: Interpolation<React.CSSProperties>
    fullScreenEnabled?: boolean;
    isParentSQ?: boolean;
}

const slideIn = keyframes`
    from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;
const slideOut = keyframes`
     from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-110%);
        width: 0;
    opacity: 0;
  }
`;

export const RightSidePanel = styled.div<props>`
        text-align: left;
        position:relative;
        padding: 0;
        background:none;
        // position: relative;

                    &.fullScreenView{
                        position: fixed;
                            left: 1%;
                            max-width: 366px;
                            top: 9.5%;
                    }


                &.fullScreenMin{
                        padding: 0px !important;
                    border-radius: 0px 10px 10px 0px;
                        height: fit-content;
                        max-width:0;
                        height:0;
                }

            @media (min-width: 1023px) and (max-width: 1399px) and (max-height: 900px) {
                &.b2cView{
                    padding-bottom:0px
                }
            }
        // @media (max-width: 980px){
        // 	.fullScreenView{
        // 		background: #f3f5f8;
        // 		padding:0px
                
        // 	}
        // }

        .save-btn{
            width: 100%;
            font-size: 1.125rem;
            line-height: 1.4;
            cursor:pointer!important;
            padding: 0.5em 1.85rem;
            margin:0;
            display:flex;
            justify-content:center;
            align-items:center;
            gap:0.5em;
            margin-top:20px;
            color: var(--textHeadingColor);
            width: 100% !important;
            padding: 0.5em 2rem 0.5em;
						border-radius: 5px;
        @media (min-width: 1023px) and (max-width: 1399px) and (max-height: 900px) {
                margin-top:10px;
        }
            
            svg{
                position: absolute;
                right: 16px;
                top:15px;
            }
            :disabled{
                cursor: not-allowed!important;
                opacity: 50%
            }
        }


        & .toggleModeFullscren{
                     transition: background 0.3s ease-in-out;
                        svg{
                             transition: transform 0.3s ease-in-out;
                        }
                        &:not(.toggleMinizedBtn){
                                &:hover{
                                    svg{
                                        transform: translateX(-2px);
                                    }
                                }
                        }

                    &.toggleMinizedBtn {
                        background: var(--defaultBgColor);
                        border: none;
                        padding: 6px;
                    border-radius: 0px 17px 17px 0px;
                        position: fixed;
                        left:0;
                        top:10.5%;
                        z-index:2;

                        svg{
                             transition: transform 0.3s ease-in-out; /* smooth */
                        }
                        &:hover{
                            opacity: 1;
                            background: var(--defaultBgLightColor);
                            box-shadow: 0 4px 10px rgba(0,0,0,0.3);
                             svg{
                              transform: translateX(2px);
                             }
                        }
                    }		
            }
`;
export const DesktopViewFixed = styled.div<props>`
        background: transparent;
        padding-inline: 1.25rem;
				padding-bottom: 1.35rem;
				padding-top:${(props) => (props.fullScreenEnabled ? '1.25rem' : '0')};
        text-align: left;
        border-radius: 8px;
        width: 100%;
        min-width: 326px;
		&.fullScreenView{
        &.screenMini{
        background: var(--modalBgColor);
            &.hideMinTansition{
                display: none;

            }
            animation: ${slideOut} 0.5s forwards ease-in-out;
            left: -1%;
        }
        &.screenMax{
            animation: ${slideIn} 0.5s forwards ease-in-out;
						background: var(--controlBgColor);
        }

        .toggle-button-cover .button {
            z-index: 0;
        }
		}
`;

export const DetailDiv = styled.div`
    display : flex;
    flex-direction: column;
    flex-wrap:wrap;
    grid-template-columns:50% 50%;
    h4 {
        color: var(--labelValueColor);
        font-weight: 400;
        font-size: 1rem;
        margin: 0;
    }

    h2 {
        color: #1457a5;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 6px 0px 0px;

        &.primary-color{
            color: var(--primary);
        }
    }
`;

export const PanelDetailDiv = styled.div<props>`
    display:flex;
    padding: ${(props) => (props.fullScreenEnabled ? '0px' : '1rem')};
    background-color:${(props) => (props.fullScreenEnabled ? 'transparent' : 'var(--defaultBgLightColor)')};
    justify-content:space-between;
    gap:.75rem;

    &:not(:last-child){
        margin-bottom:0.25rem;
    }

    &.environment-details{
        h2{
            font-size:0.8rem;
        }
        h4{
            font-size:0.9rem;
        }
    }

    input {
        margin-top: 0.3em
    }

    &.roof-panel-wrap{
            @media (max-width: 935px){
                    padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem .1rem')} ;
            }
    }
    @media (max-width: 935px){
        padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem 1rem')} ;
        background:${(props) => (props.fullScreenEnabled ? 'var(--modalBgColor)' : 'transparent')};
        &.total-gutter-area-wrap-mob{
                padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem 0.2rem')} ;
        }
    }
    @media (max-width: 540px)	{
        padding:${(props) => (props.fullScreenEnabled ? '0px' : '0.6rem 1rem 0.25rem')} ;
    }

    @media (min-width: 936px){
        flex-wrap:wrap;
    }

    @media (max-width: 640px){
        flex-wrap:wrap;
    }

    // @media (max-width: 480px){
    // 	flex-wrap:wrap;
    // 	flex-direction:column;
    // }
    &.design-mode-panel{
        padding-bottom: 0px;
        padding-top: 1rem; 
        flex-direction: column;
        gap:.15rem;
    }	

    &.b2C-roof-attrs{
      padding: 0.125rem 1rem 0.125rem;
    }
		&.total-gutter-area-wrap{
			padding: 10px;
			border-radius: 8px;
			gap: 6px;
		}	
`;

export const DesktopViewWrap = styled.div`

    &.screeview-wrap{
        display: flex;
        flex-direction: column;
        background: var(--defaultBgLightColor);
        padding: 1rem 1rem .9rem;	
        margin-bottom: .7rem;
				border-radius: 8px;
            .panels-modes-wrap{
                > div {
                        gap: .4rem;
                    }
            }
        }
        &.fullscreeview-wrap{
            display: flex;
            flex-direction: column;
            margin-bottom: .5rem;

            .panels-modes-wrap{
                flex-direction: row;
                align-items:center;
                justify-content: flex-start;
                padding-left:0;
                margin-bottom: 1.5rem;	
                > div {
                        flex-direction: row;
                        gap: .5rem;
                    }
            }
						.edit-facet-btn{
							border: 1px solid var(--borderColor);
							background: var(--btnBgdefault);
							border-radius: 8px;
						&:hover{
							background: var(--surfaceColor);
						}
					}	
					.solar-imagery-wrap{
						padding-bottom: 3px;
						
						span{
							svg{
								width: 36px;
								height: 36px;
							}
						}
					}			
        }

	&.roof-detail{
		margin-bottom: 1rem;
	}
	&.custom-map-desktop{
		margin-bottom: .625rem;
	}
	&.defaultScreenView{
	 .solar-imagery-wrap{
	 		@media (min-width:981px) and (max-width: 1069px){
				display : flex;
				flex-direction: column;
				gap: 6px;
			}
	 }	
	}	
`;

export const DivSolarImagery = styled.div`
    width: 100%;
		padding-top: 3px;
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 12px;
		
		.solar-imagery-wrap{
			padding-bottom: 3px;
			
			span{
				svg{
					width: 36px;
					height: 36px;
				}
			}
		}	
`;

// export const DivLabel = styled.div`
// 	    display: flex;
//     	align-items: center;
//     	gap: 6px;
// 			color: rgb(46, 56, 77);
// 			font-family: Inter;
// 			font-size: 1rem;
// 			font-weight: 600;
// 			margin-bottom: 0;

// 			@media (max-width: 1339px){
// 			 font-size: 0.95rem;

// 			 svg{ width: 18px; height: 18px}
// 			}

// 			&.roof-attr-label{
// 				font-weight: 400;
// 			}
// `;
// export const DivValue = styled.div`
// 			display: flex;
//     	align-items: center;
//     	gap: 5px;
// 			font-family: Inter;
// 			color:rgb(46, 56, 77);
//     	font-size: .9rem;
// 			line-height:20px;
//     	font-weight: 500;

// 			@media (max-width: 1339px){
// 			 font-size: 0.85rem;

// 			 svg{ width: 18px; height: 18px}
// 			}

// 			&.roof-attr-value{
// 				color: var(--primary);
// 				font-size: 1.125rem;
//     		font-weight: 600;
// 			}
// `;

export const DesktopSidePanel = styled.div`
    width: 100%;
    position: relative;

    &.fullViewMode{
        // &.fullScreenViewMinized{
        //     opacity: 0;
        // }		 
    }
`;

export const ModeToggleDiv = styled.div`
        display: flex;
    width: auto;
        position: absolute;
    right: -36px;
    width: auto;
    top: -13px;

        &.modeMinized{
            margin-bottom: 0;
            width: auto;
        }
    & .toggleModeFullscren{
            background: var(--lightBlue);
            height: 38px;
            width: 38px;
            min-width: 24px;
            min-height: 24px;
            padding:0;
            border: 1px solid var(--lightBlue);
            border-radius: 24px;
            isplay: flex;
            align-items: center;
            justify-content: center;
            gap:0;
            position: relative;

            &:hover, &:active{
                box-shadow: 0px 0px 1px 0px #ccc;
                background: rgb(230 237 249);
                opacity: 1;
                background: var(--defaultBgLightColor);
            }	
     }

`;
export const EditFacetModalBtnWrap = styled.div`
    button.edit-facet-btn{
        margin-top: 3px;
        margin-bottom: .5rem;
        background: var(--btnBgdefault);
        width: 100%;
        color:var(--textTitleColor);
        font-weight: 500;
        // border: 1px solid #D6D6D6;
        font-size: 15px;
        line-height: 18px;
        cursor: pointer !important;
        padding: 10px 2rem;
        // border-radius: 2rem;
        gap:8px;
				border: 1px solid var(--borderColor);
    		border-radius: 8px;
			&:disabled{
				cursor: not-allowed !important;
				opacity: .6 !important;
			}
    }
    `;

